import { atom } from 'recoil';

export const drawerOpen = atom({
  key: 'sidebarDrawer',
  default: false,
});
